import React from "react";
import { Empty } from "antd";

/**
 * حالت خالی فشرده و غیرمزاحم — جایگزین باکس‌های راهنمای بزرگ.
 * فضای کمی می‌گیرد، وسط‌چین سبک، و layout را به‌هم نمی‌زند.
 *
 * props:
 *   message — متن راهنما
 *   action  — (اختیاری) دکمه/المان عملیاتی زیر متن
 *   minHeight — ارتفاع حداقلی (پیش‌فرض 160)
 *   small — نسخهٔ بسیار فشرده برای ستون‌های باریک
 */
export default function EmptyWorkArea({ message, action, minHeight = 160, small = false }) {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: small ? 90 : minHeight,
        padding: small ? "12px 8px" : "16px",
        textAlign: "center",
      }}
    >
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        styles={{ image: { height: small ? 36 : 56 } }}
        description={
          <span style={{ color: "#999", fontSize: small ? 12 : 13 }}>{message}</span>
        }
      >
        {action}
      </Empty>
    </div>
  );
}
